import { createContext, useContext } from 'react';

/** The router's address as it is now, not as last rendered. */
export type LiveAddress = () => { pathname: string; search: string };

/**
 * Where the URL-state hooks read the latest address from: the address bar, or, for a page shown in the
 * link dialog (SF-T-160), that dialog's own router (its page's query isn't in the address bar).
 */
export const LiveAddressContext = createContext<LiveAddress>(() => window.location);

export function useLiveAddress(): LiveAddress {
  return useContext(LiveAddressContext);
}

/**
 * True in a router whose history is its own (the link dialog's memory history): the unsaved-changes
 * guard's spare entry is in the browser's history, not this one, so record history has none to step over.
 */
export const OwnHistoryContext = createContext(false);

export function useOwnHistory(): boolean {
  return useContext(OwnHistoryContext);
}
